import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { labelKey: "nav.overview", href: "#overview" },
    { labelKey: "nav.transport", href: "#transport" },
    { labelKey: "nav.contracts", href: "#contracts" },
    { labelKey: "nav.profitability", href: "#profitability" },
    { labelKey: "nav.market", href: "#market" },
    { labelKey: "nav.contact", href: "#contact" },
  ];

  const contractLinks = [
    { name: "Entry — $3,000", rate: "30% ROI" },
    { name: "Standard — $5,000", rate: "40% ROI" },
    { name: "Premium — $10,000", rate: "50% ROI" },
  ];

  return (
    <footer className="bg-[#080808] border-t border-white/5 py-14 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-[#c9a84c] rounded-full">
                <i className="ri-drop-fill text-[#0b0b0b] text-lg" />
              </div>
              <div>
                <span className="text-white font-bold text-lg">Saudi<span className="text-[#c9a84c]">Aramco</span></span>
                <p className="text-[#c9a84c]/50 text-[10px] tracking-widest uppercase -mt-0.5">Investment Portal</p>
              </div>
            </div>
            <p className="text-white/40 text-sm leading-relaxed max-w-sm">{t("footer.desc")}</p>
            <div className="flex gap-3 mt-5">
              {["ri-twitter-x-fill", "ri-linkedin-fill", "ri-telegram-fill"].map((icon) => (
                <div key={icon} className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-[#c9a84c]/20 border border-white/10 hover:border-[#c9a84c]/40 rounded-lg transition-colors cursor-pointer">
                  <i className={`${icon} text-white/60 hover:text-[#c9a84c] text-sm transition-colors`} />
                </div>
              ))}
            </div>
          </div>

          <div>
            <p className="text-[#c9a84c] font-bold text-xs uppercase tracking-widest mb-4">{t("footer.navTitle")}</p>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <button onClick={() => scrollTo(l.href)} className="text-white/50 hover:text-[#c9a84c] text-sm transition-colors cursor-pointer">
                    {t(l.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[#c9a84c] font-bold text-xs uppercase tracking-widest mb-4">{t("footer.contractsTitle")}</p>
            <ul className="space-y-3">
              {contractLinks.map((c) => (
                <li key={c.name} className="flex items-center justify-between">
                  <span className="text-white/50 text-sm">{c.name}</span>
                  <span className="text-[#c9a84c] text-xs font-bold">{c.rate}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 bg-[#c9a84c]/10 border border-[#c9a84c]/20 rounded-xl p-4">
              <p className="text-[#c9a84c] font-black text-sm mb-1">{t("footer.readyTitle")}</p>
              <p className="text-white/50 text-xs mb-3">{t("footer.readyDesc")}</p>
              <button onClick={() => scrollTo("#contracts")}
                className="w-full bg-[#c9a84c] text-[#0b0b0b] text-xs font-black py-2 rounded-lg cursor-pointer whitespace-nowrap hover:bg-[#b8962e] transition-colors">
                {t("footer.viewContracts")}
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs">{t("footer.copyright")}</p>
          <p className="text-white/20 text-xs text-center sm:text-right max-w-md">{t("footer.legalNote")}</p>
        </div>
      </div>
    </footer>
  );
}
